import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import Nav from "../components/Nav";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      if (res.data?.token) localStorage.setItem("alta_admin_token", res.data.token);
      toast.success("Bem-vindo(a)");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6] flex flex-col" data-testid="admin-login">
      <Nav variant="admin" />
      <div className="flex-1 flex items-center">
        <div className="max-w-[820px] mx-auto w-full px-6 md:px-12 py-24">
          <Logo variant="dark" size={72} testid="admin-login-alta-logo" className="mb-10" />
          <div className="eyebrow">Painel · Curadoria</div>
          <h1 className="mt-8 serif text-[44px] md:text-[68px] leading-[1] tracking-[-0.01em]">
            Alta Agency<br />
            <em className="italic text-[color:var(--alta-red)]">acesso interno.</em>
          </h1>
          <form onSubmit={submit} className="mt-16 space-y-10 max-w-[520px]">
            <label className="block">
              <span className="mono text-[10px] uppercase tracking-[0.28em] text-neutral-500">E-mail</span>
              <input
                data-testid="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="field-line mt-3"
                autoComplete="username"
              />
            </label>
            <label className="block">
              <span className="mono text-[10px] uppercase tracking-[0.28em] text-neutral-500">Senha</span>
              <input
                data-testid="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="field-line mt-3"
                autoComplete="current-password"
              />
            </label>
            <button
              data-testid="admin-submit"
              type="submit"
              disabled={loading}
              className="btn-sharp"
            >
              {loading ? "Entrando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
